import { model as i18n } from '!/i18n'
import {
  api,
  type GetPartnerProductParams,
  type PartnerProductDetails,
} from '@setplex/tria-api'
import { combine, createEvent, createStore, sample } from 'effector'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { formatPartnerProductDetailsItem } from '../helpers'

export const resetPartnerProductDetails = createEvent()
const partnerProductDetailsLoaded = createEvent<PartnerProductDetails>()

export const $partnerProductDetails = createStore<PartnerProductDetails | null>(
  null
)
  .on(partnerProductDetailsLoaded, (_, partnerProduct) => partnerProduct)
  .reset(resetPartnerProductDetails)

export const $partnerProductDetailsFormatted = combine(
  $partnerProductDetails,
  ssePurchasesModel.$partnerProduct,
  i18n.$t,
  (partnerProductDetails, adjust) =>
    partnerProductDetails &&
    formatPartnerProductDetailsItem(adjust(partnerProductDetails))
)

export const $partnerProductDetailsLoading =
  api.partnerProgram.getPartnerProductDetailsFx.pending

export const loadPartnerProductDetails = createEvent<GetPartnerProductParams>()

sample({
  clock: loadPartnerProductDetails,
  target: api.partnerProgram.getPartnerProductDetailsFx,
})

sample({
  clock: api.partnerProgram.getPartnerProductDetailsFx.doneData,
  target: partnerProductDetailsLoaded,
})
